import { render } from "./CardForm.vue?vue&type=template&id=fa85e91a&scoped=true"
import script from "./CardForm.vue?vue&type=script&lang=ts"
export * from "./CardForm.vue?vue&type=script&lang=ts"

import "./CardForm.vue?vue&type=style&index=0&id=fa85e91a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-fa85e91a"

export default script